// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"a0678be5","453":"c8b80cf6","897":"48c4415b","921":"171cbb6f"}[chunkId] + ".chunk.js";
};